<template>
  <classic-container :title="$t('site-administration.instant-charge.title')">
    <div class="classic-container-row">
      <p> {{ $t('site-administration.instant-charge.paragraph-1') }} </p>
      <p> {{ $t('site-administration.instant-charge.paragraph-2') }} </p>
    </div>
    <v-switch
      color="orange"
      v-model="instantCharge"
      :label="$t('site-administration.instant-charge.switch.description')"
      @click="onSwitched"
      readonly
    />
  </classic-container>
</template>

<script>
import ClassicContainer from '../classic-container'

export default {
  components: { ClassicContainer },
  props: {
    instantCharge: { type: Boolean, required: true },
    onSwitchedOn: { type: Function, required: true },
    onSwitchedOff: { type: Function, required: true }
  },
  methods: {
    onSwitched () {
      if (this.instantCharge === false) {
        this.onSwitchedOn()
      } else {
        this.onSwitchedOff()
      }
    }
  }
}
</script>

<style scoped>

.classic-container-row {
  width: 100%
}

</style>
